import { API_LOCATION_URL } from 'infrastructure/config';
import { IGetResponse, IAgentCompanyListingsClient } from 'interfaceAdapter/gatewaySchemas/IAgentCompanyListingsClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class AgentCompanyListingsClient implements IAgentCompanyListingsClient {
    async get(input: any): Promise<IGetResponse> {
        const { token } = input;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-A': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        const params = new URLSearchParams();
        if (input.industry && Array.isArray(input.industry)) {
            input.industry.forEach((ind: string) => {
                params.append('industry', ind);
            });
        }

        if (input.area && Array.isArray(input.area)) {
            input.area.forEach((area: string) => {
                params.append('area', area);
            });
        }

        if (input.keyword) {
            params.append('keyword', input.keyword);
        }

        if (input.number_of_employees && Array.isArray(input.number_of_employees)) {
            input.number_of_employees.forEach((emp: string) => {
                params.append('number_of_employees', emp);
            });
        }

        if (input.profit_level && Array.isArray(input.profit_level)) {
            input.profit_level.forEach((profit: string) => {
                params.append('profit_level', profit);
            });
        }

        if (input.net_assets_level && Array.isArray(input.net_assets_level)) {
            input.net_assets_level.forEach((net: string) => {
                params.append('net_assets_level', net);
            });
        }

        if (input.revenue_scale && Array.isArray(input.revenue_scale)) {
            input.revenue_scale.forEach((revenue: string) => {
                params.append('revenue_scale', revenue);
            });
        }

        if (input.prefecture && Array.isArray(input.prefecture)) {
            input.prefecture.forEach((pref: string) => {
                params.append('prefecture', pref);
            });
        }

        if (input.limit) {
            params.append('limit', input.limit.toString());
        }

        if (input.offset) {
            params.append('offset', input.offset.toString());
        }

        if (input.sort) {
            params.append('sort', input.sort);
        }
        const queryString = params.toString();
        const PATH = `${API_LOCATION_URL}/agent/company/listings?${queryString}`;
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
